module.exports = __webpack_public_path__ + "static/media/sapo-barriga-vermelha.54f471d4.mp3";